import type { AnalyticsDecorator } from './types'

export const analyticsDecoratorLabelsMap: Record<AnalyticsDecorator, string> = {
  membershipsV2: 'Memberships analytics v2',
  shopV2: 'Shop analytics v2',
}
